import { render, staticRenderFns } from "./ots.vue?vue&type=template&id=689aee5c&scoped=true&"
import script from "./ots.vue?vue&type=script&lang=js&"
export * from "./ots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689aee5c",
  null
  
)

export default component.exports